import { defineStore } from 'pinia';
import * as reportAgentApi from '@/services/reportAgentApi';

// Saved AI reports. They live in Web.Api (the ReportDefinition table) and are shared by
// every user - nothing here is kept in the browser. Separate from Report Templates /
// My Reports, which keep their own saving.

// The request currently fetching saved reports, if any, so pages asking at the same time
// share one call.
let loading = null;

function asReport(dto) {
    return {
        id: dto.id,
        name: dto.name,
        question: dto.question,
        toolId: dto.toolId,
        parameters: dto.parameters || {},
        ownerName: dto.ownerName,
        isMine: dto.isMine,
        modifiedOn: dto.modifiedOn,
    };
}

export const useAiReportsStore = defineStore('aiReports', {
    state: () => ({
        reports: [],
        loaded: false,
    }),
    getters: {
        getById: state => id => state.reports.find(r => r.id === Number(id)),
    },
    actions: {
        // A failure leaves an empty list rather than a broken page.
        load() {
            if (!loading) {
                loading = reportAgentApi.listReports()
                    .then(reports => {
                        this.reports = reports.map(asReport);
                    })
                    .catch(() => {
                        this.reports = [];
                    })
                    .finally(() => {
                        this.loaded = true;
                        loading = null;
                    });
            }

            return loading;
        },
        // Owner only; the pages never offer these to anyone else (a 403 sends the app to
        // its Unauthorized page). The location is the one selected, for matching names.
        async update(id, changes, locationId) {
            const updated = asReport(await reportAgentApi.updateReport(id, { ...changes, locationId }));
            this.reports = this.reports.map(r => (r.id === updated.id ? updated : r));
            return updated;
        },
        async remove(id) {
            await reportAgentApi.deleteReport(id);
            this.reports = this.reports.filter(r => r.id !== Number(id));
        },
    },
});
